import { render } from "./QuestionsRenderer.vue?vue&type=template&id=74d0f01c&ts=true"
import script from "./QuestionsRenderer.vue?vue&type=script&lang=ts"
export * from "./QuestionsRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__